// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"139":"3fa2c935","278":"a8feb9c4","305":"33c52923","370":"cb07337a","552":"c953b625","850":"68298372"}[chunkId] + ".chunk.css";
};